module.exports = __webpack_public_path__ + "img/57_13.d5ee7b4c.png";